import { PropTypes } from "aem/ComponentWrapper";
export default {
  title: "Text Custom",
  type: "rh/components/content/textCustom",
  superType: "core/wcm/components/text/v2/text",
  config: {
    emptyLabel: "Empty Text",
    isEmpty: (_: PropTypes) => false
  }
};
